<template lang='pug'>
  el-dialog.unistar-quotation-dialog(
    :visible='visible'
    :title="title"
    @close='closeDialog'
    width='920px'
    :close-on-click-modal='false'
    center
  )
    el-row(:gutter="20")
      el-col.title(:span="4") {{ $t('合作期限') }}
      el-col(:span="20")
        div(style="display: flex")
          el-date-picker(
            v-model="data.star_offer_date.start_date"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('开始日期')"
            :picker-options="startDatePickerOptions"
            style="width: 180px"
          )
          span(style="margin: 0 10px" class="line") {{ $t('至') }}
          el-date-picker(
            v-model="data.star_offer_date.end_date"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('结束日期')"
            :picker-options="endDatePickerOptions"
            style="width: 180px"
          )
    el-row(:gutter='20')
      el-col.title.required(:span='4') {{ $t('报价') }}
      el-col(:span='20')
        el-table(
          v-loading='loading'
          :data='data.star_offer_price.price'
          :key='index'
          max-height='240'
        )
          el-table-column(
            prop='star_service_id'
            align='left'
            :label='$t("服务类别")'
            min-width='160'
            :show-overflow-tooltip='viewMode'
            :render-header='renderHeader'
            class="first-header-col"
          )
            template(slot-scope='scope')
              i.iconfont.icon-shanchu1(
                v-if="scope.$index !== 0"
                @click="delRow('star_offer_price',scope)"
              )
              span(
                v-else
                style="width: 10px;display:inline-block;margin-left:8px"
              )
              el-select(
                v-model='scope.row.star_service_id'
                :placeholder='$t("请选择类别")'
                size='mini'
                style='width: 110px; margin-left: 3px'
                @change='e => { handleServiceChange(e, scope.row) }'
              )
                el-option(
                  v-for='o, i in serviceList'
                  :key='i'
                  :label='isZh ? o.star_service_name_ch : o.star_service_name'
                  :value='o.star_service_id'
                )

          el-table-column(
            prop='star_service_item_name'
            :label='$t("服务项目")'
            align='left'
            min-width='140'
            :show-overflow-tooltip='viewMode'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.star_service_item_name }}
              template(v-else)
                el-select(
                  v-if='getServiceItemList(scope.row.star_service_id).length > 0'
                  v-model='scope.row.star_service_item_name'
                  placeholder=''
                  size='mini'
                  @change='v => handleServiceItemSelect(getServiceItemList(scope.row.star_service_id), scope.row)'

                )
                  el-option(
                    v-for='o, i in getServiceItemList(scope.row.star_service_id)'
                    :key='i'
                    :label='isZh ? o.star_service_item_name_ch : o.star_service_item_name'
                    :value='o.star_service_item_name'
                    :disabled="data.star_offer_price.price.map(i => i.star_service_item_id).includes(o.star_service_item_id)"
                  )
                el-input(
                  v-else
                  v-model='scope.row.star_service_item_name'
                  :maxlength='100'
                  :placeholder='$t("≤100字")'
                  @change='v => handleServiceItemInput(v, scope.row)'
                  :disabled='checkShouldDisabled(scope.row.is_asset)'
                )

          el-table-column(
            prop='unitPrice'
            :label='$t("单价")'
            align='left'
            min-width='150'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.unit_price | formatMoney }}
              vue-numeric(
                v-else
                v-model='scope.row.unit_price'
                :unit="$t('元')"
                :precision='2'
              )
          el-table-column(
            prop='number'
            :label='$t("数量")'
            align='left'
            min-width='100'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.number | numberWithCommas }}
              template(v-else)
                input-with-commas(
                  :allowZero="true"
                  v-model='scope.row.number'
                  :disabled='checkShouldDisabled(scope.row.is_asset)'
                )
          el-table-column(
            width='150'
            align='right'
          )
            template(slot-scope='scope')
              span {{ getTotalPrice(scope.row) | formatMoney }}
        .table-footer
          el-button(
            v-if='!viewMode'
            type='text'
            @click='addRow("star_offer_price")'
          ) + {{ $t("添加报价") }}
          .total_price
            span {{ $t('总计') }}
            span {{ getTableTotalPrice('star_offer_price', false) | formatMoney }}
    el-row(:gutter='20')
      el-col.title.required(:span='4') {{ $t('权益') }}
      el-col(:span='20')
        el-table(
          v-loading='loading'
          :data='data.star_right_price.price'
          :key='index'
          max-height='240'
        )
          el-table-column(
            prop='right_service_id'
            align='left'
            :label='$t("权益类型")'
            min-width='160'
            :show-overflow-tooltip='viewMode'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              i.iconfont.icon-shanchu1(
                style='color: #3370d2;line-height: 29px;font-size:10px;cursor:pointer'
                v-if="scope.$index !== 0"
                @click="delRow('star_right_price',scope)"
              )
              span(
                v-else
                style="width: 10px;display:inline-block;margin-left:8px"
              )
              span(v-if='viewMode' style='margin-left: 3px') {{ scope.row.right_service_name }}
              el-select(
                v-else
                v-model='scope.row.right_service_id'
                :placeholder='$t("请选择类别")'
                size='mini'
                style='width: 110px; margin-left: 3px'
                @change='e => {handleRightServiceChange(e, scope.row)}'
              )
                el-option(
                  v-for='o, i in rightServiceList'
                  :key='i'
                  :label='isZh ? o.right_service_name_ch : o.right_service_name'
                  :value='o.right_service_id'
                )

          el-table-column(
            prop='right_service_item_name'
            :label='$t("权益项目")'
            align='left'
            min-width='140'
            :show-overflow-tooltip='viewMode'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.right_service_item_name_ch}}
              template(v-else)
                el-select(
                  v-if='getRightServiceItemList(scope.row.right_service_id).length > 0'
                  v-model='scope.row.right_service_item_name'
                  placeholder=''
                  size='mini'
                  @change='v => handleRightServiceItemSelect(getRightServiceItemList(scope.row.right_service_id), scope.row)'
                )
                  el-option(
                    v-for='o, i in getRightServiceItemList(scope.row.right_service_id)'
                    :key='i'
                    :label='isZh ? o.right_service_item_name_ch : o.right_service_item_name'
                    :value='isZh ? o.right_service_item_name_ch : o.right_service_item_name'
                    :disabled="checkShouldDisabledRightItem(o.right_service_item_id)"
                  )
                el-input(
                  v-else
                  v-model='scope.row.right_service_item_name'
                  :maxlength='100'
                  :placeholder='$t("≤100字")'
                  @change='v => handleRightServiceItemInput(v, scope.row)'
                )

          el-table-column(
            prop='unitPrice'
            :label='$t("可行性")'
            align='left'
            min-width='150'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.is_confirm ? '是' : '否'}}
              template(
                v-else
              )
                el-radio-group(
                  v-if="scope.row.flexibility === 1"
                  v-model="scope.row.is_confirmed"
                )
                  el-radio(:label="1") {{ $t('是') }}
                  el-radio(:label="0") {{ $t('否') }}
                span(v-else) —
          el-table-column(
            prop='number'
            :label='$t("数量")'
            align='left'
            min-width='100'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.number | numberWithCommas }}
              template(v-else)
                input-with-commas(
                  v-model='scope.row.number'
                  :allowZero="true"
                  :disabled='checkShouldDisabled(scope.row.is_asset)'
                )
          el-table-column(
            prop='number'
            :label="$t('工作日')"
            align='left'
            min-width='120'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.workday | numberWithCommas }}
              template(v-else)
                input-with-commas(
                  v-if="scope.row.flexibility"
                  v-model='scope.row.workday'
                )
                span(v-else) —
        .table-footer
          el-button(
            v-if='!viewMode'
            type='text'
            @click='addRightRow("star_right_price")'
          ) + {{ $t("添加权益") }}

    // 执行价目表
    el-row(:gutter='20')
      el-col.title(
        :span='4'
        :class="[executionPriceRequired ? 'required' : '']"
      ) {{ $t('执行价目表') }}
      el-col(:span='20')
        el-table(
          v-loading='loading'
          :data='data.star_execution_price.price'
          :key='index'
          max-height='240'
        )
          el-table-column(
            prop='star_service_id'
            align='left'
            :label='$t("服务类别")'
            min-width='160'
            :show-overflow-tooltip='viewMode'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              i.iconfont.icon-shanchu1(
                style='color: #3370d2;line-height: 29px;font-size:10px;cursor:pointer'
                v-if="scope.$index !== 0 || (scope.$index === 0 && !executionPriceRequired)"
                @click="delRow('star_execution_price',scope)"
              )
              span(
                v-else
                style="width: 10px;display:inline-block;margin-left:8px"
              )
              span(v-if='viewMode' style='margin-left: 3px') {{ isZh ? scope.row.star_service_name_ch : scope.row.star_service_name }}
              el-select(
                v-else
                v-model='scope.row.star_service_id'
                :placeholder='$t("请选择类别")'
                size='mini'
                style='width: 110px; margin-left: 3px'
                @change='e => { handleExecutionServiceChange(e, scope.row) }'
              )
                el-option(
                  v-for='o, i in executionServiceList'
                  :key='i'
                  :label='isZh ? o.star_service_name_ch : o.star_service_name'
                  :value='o.star_service_id'
                )

          el-table-column(
            prop='star_service_item_name'
            :label='$t("服务项目")'
            align='left'
            min-width='140'
            :show-overflow-tooltip='viewMode'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ isZh ? scope.row.star_service_item_nameCh : scope.row.star_service_item_name }}
              template(v-else)
                el-select(
                  v-if='getExecutionServiceItemList(scope.row.star_service_id).length > 0'
                  v-model='scope.row.star_service_item_name'
                  placeholder=''
                  size='mini'
                  @change='v => handleServiceItemSelect(getExecutionServiceItemList(scope.row.star_service_id), scope.row)'
                )
                  el-option(
                    v-for='o, i in getExecutionServiceItemList(scope.row.star_service_id)'
                    :key='i'
                    :label='isZh ? o.service_item_name_ch : o.star_service_item_name'
                    :value='o.star_service_item_name'
                    :disabled="data.star_execution_price.price.map(i => i.star_service_item_id).includes(o.star_service_item_id)"
                  )
                el-input(
                  v-else
                  v-model='scope.row.star_service_item_name'
                  :maxlength='100'
                  :placeholder='$t("≤100字")'
                  @change='v => handleServiceItemInput(v, scope.row)'
                  :disabled='checkShouldDisabled(scope.row.is_asset)'
                )

          el-table-column(
            prop='unitPrice'
            :label='$t("单价")'
            align='left'
            min-width='150'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.unit_price | formatMoney }}
              vue-numeric(
                v-else
                v-model='scope.row.unit_price'
                :unit="$t('元')"
                :precision='2'
              )
          el-table-column(
            prop='number'
            :label='$t("数量")'
            align='left'
            min-width='100'
            :render-header='renderHeader'
          )
            template(slot-scope='scope')
              span(v-if='viewMode') {{ scope.row.number | numberWithCommas }}
              template(v-else)
                input-with-commas(
                  :allowZero="true"
                  v-model='scope.row.number'
                  :disabled='checkShouldDisabled(scope.row.is_asset)'
                )
          el-table-column(
            width='150'
            align='left'
          )
            template(slot-scope='scope')
              span {{ getTotalPrice(scope.row) | formatMoney }}
        .table-footer
          el-button(
            v-if='!viewMode'
            type='text'
            @click='addRow("star_execution_price")'
          ) + {{ $t("添加报价") }}
          .total_price
            span {{ $t('总计') }}
            span {{ getTableTotalPrice('star_execution_price', false) | formatMoney }}
    .dialog-footer(slot="footer")
        el-button(
          @click='handleConfirm'
          type="primary"
        ) {{ $t('确定') }}
        el-button(
          @click='$emit("close")'
          type="plain"
        ) {{ $t('取消') }}
</template>

<script>
import axios from 'axios'
import { numberWithPercent, formatMoney, numberWithCommas, formatDate, numMulti } from '@/umcc/util'
import dayjs from 'dayjs'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import InputWithCommas from '@/components/InputWithCommas'
import db from '@/umcc/db'
import accounting from 'accounting-js'
import VueNumeric from '@/components/VueNumeric'
import TitleBar from '@/components/TitleBar'
import { pickBy } from 'lodash'

export function normalizeQuotation (star) {
  let q = {}
  // 默认每个category会有一个空的报价
  q = {
    'star_name': star.star_name,
    'star_id': star.star_id,
    tax_price: star.tax_price || null,
    star_offer_date: {
      'start_date': (star.star_offer_date && star.star_offer_date.start_date) ? star.star_offer_date.start_date : '',
      'end_date': (star.star_offer_date && star.star_offer_date.end_date) ? star.star_offer_date.end_date : ''
    },
    'star_offer_price': {
      'tax_total_price': star.star_offer_price.tax_total_price || '',
      'tax_price': star.star_offer_price.tax_price || ''
    },
    'star_right_price': {
    },
    'star_execution_price': {
      'tax_total_price': star.star_execution_price.tax_total_price || '',
      'tax_price': star.star_execution_price.tax_price || ''
    }
  }

  const defaultOfferPrice = [{
    'number': '',
    'star_service_name': '',
    'star_service_id': '',
    'total_price': '',
    'star_service_item_id': '',
    'unit_price': 0,
    'star_service_item_name': ''
  }]
  const defaultExecutionPrice = [{
    'number': '',
    'star_service_name': '',
    'star_service_id': '',
    'total_price': '',
    'star_service_item_id': '',
    'unit_price': 0,
    'star_service_item_name': ''
  }]
  const defaultRightPrice = [
    {
      'number': null,
      'right_service_name': '',
      'right_service_id': '',
      'right_service_item_id': '',
      'right_service_item_name': '',
      'workday': '',
      is_confirmed: null
    }
  ]

  q.star_offer_price.price = star.star_offer_price.price.length ? star.star_offer_price.price : defaultOfferPrice

  q.star_right_price.price = star.star_right_price.price.length ? star.star_right_price.price : defaultRightPrice

  q.star_execution_price.price = star.star_execution_price.price.length ? star.star_execution_price.price : defaultExecutionPrice
  return q
}

export function formatQuotationParams (quotationData, processType, campaignId) {
  let res = {
    campaign_id: campaignId,
    process_type: processType
  }
  res.star_info = quotationData.map(i => {
    return {
      star_id: i.star_id
    }
  })
  res.star_offer_price = quotationData.map(i => {
    return i.star_offer_price.price.map(j => {
      const res = {
        star_service_id: j.star_service_id,
        star_service_item_id: j.star_service_item_id,
        unit_price: j.unit_price,
        number: j.number,
        total_price: j.total_price
      }
      return pickBy(res, v => { return v != null })
    })
  })
  res.star_right_price = quotationData.map(i => {
    return i.star_right_price.price.map(j => {
      const res = {
        right_service_id: j.right_service_id,
        right_service_item_id: j.right_service_item_id,
        workday: j.workday,
        number: j.unit_price,
        is_confirmed: j.is_confirmed
      }
      return pickBy(res, v => { return v != null })
    })
  })
  res.star_execution_price = quotationData.map(i => {
    return i.star_execution_price.price.map(j => {
      const res = {
        star_service_id: j.star_service_id,
        star_service_item_id: j.star_service_item_id,
        unit_price: j.unit_price,
        number: j.number,
        total_price: j.total_price
      }
      return pickBy(res, v => { return v != null })
    })
  })
  return res
}

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    executionPriceRequired: {
      type: Boolean,
      default: false // 执行价是否必填
    },
    data: {
      type: Object,
      default () {
        return {
          'star_name': '',
          'star_id': null,
          'star_offer_price': {
            'total_price': null,
            'price': [
              {
                'number': null,
                'star_id': null,
                'star_service_name': '',
                'star_service_id': null,
                'total_price': null,
                'star_service_item_id': null,
                'unit_price': null,
                'star_service_item_name': ''
              }
            ],
            'tax_price': 0.060
          },
          'star_right_price': {
            'price': [
              {
                'right_service_name': '',
                'right_service_id': null,
                'workday': null,
                'right_service_item_id': null,
                'right_service_item_name': '',
                'number': null,
                is_confirmed: null
              }
            ]
          },
          'tax_price': null,
          'star_execution_price': {
            'total_price': null,
            'price': [
              {
                'number': null,
                'star_id': null,
                'star_service_name': '',
                'star_service_id': 1,
                'total_price': null,
                'star_service_item_id': null,
                'unit_price': null,
                'star_service_item_name': ''
              }
            ],
            'tax_price': null
          }
        }
      }
    }
  },
  data () {
    return {
      loading: false,
      serviceList: [],
      kolTemplateUrl: null,
      hasKolBuying: true,
      KolFailReport: null,
      rightServiceList: [],
      executionServiceList: [],
      startDatePickerOptions: {
        disabledDate: (time) => {
          if (this.data.star_offer_date.end_date) {
            return time.getTime() > dayjs(this.data.star_offer_date.end_date).unix() * 1000
          }
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          if (this.data.star_offer_date.start_date) {
            return time.getTime() < dayjs(this.data.star_offer_date.start_date).unix() * 1000
          }
        }
      }
    }
  },
  computed: {
    isZh () {
      return db.lang === 'zh'
    }
  },
  mounted () {
    console.log('debug')
    this.fetchServiceList()
    this.fetchRightServiceList()
    this.fetchStarExecutionServiceList()
  },
  filters: {
    formatMoney,
    numberWithCommas,
    numberWithPercent,
    formatDate,
    TitleBar
  },
  methods: {
    getTableTotalPrice (type, needFormat) {
      if (this.data[type]) {
        const price = this.data[type].price
        const sum = price.map(p => p.total_price).reduce((a, b) => a + b)
        this.data[type].tax_price = sum ? sum * 0.06 : 0
        this.data[type].tax_total_price = sum ? ((sum * 0.06) + sum) : 0
        if (needFormat) {
          return sum ? isNaN(sum.toFixed(2)) ? '-' : numMulti(sum.toFixed(2), 0.0001) : '-'
        } else {
          return sum ? isNaN(sum.toFixed(2)) ? '-' : sum.toFixed(2) : '-'
        }
      }
    },
    handleBlur (val, row) {
      row.unitPrice = accounting.toFixed(row.unitPrice, 2)
    },
    handlePriceAfterLeveragingBlur (val, row) {
      row.priceAfterLeveraging = accounting.toFixed(row.priceAfterLeveraging, 2)
    },
    checkShouldDisabled (isAsset) {
      return this.hasSync && this.checkIsAsset && isAsset === 1
    },
    renderHeader (h, { column, $index }) {
      return <span class='required'>
        { column.label }
      </span>
    },
    handleServiceChange (id, row) {
      // 重置项目及单价
      row.unit_price = 0
      row.star_service_item_name = ''
      row.star_service_name = this.isZh ? this.serviceList.find(s => s.star_service_id === id).star_service_name_ch : this.serviceList.find(s => s.star_service_id === id).star_service_name
    },
    handleExecutionServiceChange (id, row) {
      // 重置执行项目及单价
      row.unit_price = 0
      row.star_service_item_name = ''
      row.star_service_name = this.isZh ? this.executionServiceList.find(s => s.star_service_id === id).star_service_name_ch : this.executionServiceList.find(s => s.star_service_id === id).star_service_name
    },
    handleRightServiceChange (id, row) {
      // 重置项目及单价
      row.unit_price = 0
      row.right_service_item_name = ''
      row.right_service_name = this.isZh ? this.rightServiceList.find(s => s.right_service_id === id).right_service_name_ch : this.rightServiceList.find(s => s.right_service_id === id).right_service_name
      // row.right_service_name = this.rightServiceList.find(s => s.right_service_id === id).right_service_name
    },
    getServiceItemList (id) {
      const list = this.serviceList.find(i => i.star_service_id === id)
      if (!list) return []
      return list.children
    },
    getExecutionServiceItemList (id) {
      const list = this.executionServiceList.find(i => i.star_service_id === id)
      if (!list) return []
      return list.children
    },
    getRightServiceItemList (id) {
      const list = this.rightServiceList.find(i => i.right_service_id === id)
      if (!list) return []
      return list.children
    },
    async fetchRightServiceList () {
      const res = await axios.get('/management/star/getRightServiceList')
      const serviceItemList = await Promise.all(res.map(item => axios.get('/management/star/getRightServiceItemList', {
        params: { right_service_id: item.right_service_id }
      })))
      this.rightServiceList = res.map((item, index) => {
        item.children = serviceItemList[index]
        return item
      })
    },
    async fetchServiceList () {
      this.loading = true
      const res = await axios.get('/management/star/getStarServiceList')
      const serviceItemList = await Promise.all(res.map(item => axios.get('/management/star/getStarServiceItemList', {
        params: { star_service_id: item.star_service_id }
      })))
      this.serviceList = res.map((item, index) => {
        item.children = serviceItemList[index]
        return item
      })
      this.loading = false
    },
    async fetchStarExecutionServiceList () {
      this.loading = true
      const res = await axios.get('/management/star/getStarExecutionServiceList')
      const serviceItemList = await Promise.all(res.map(item => axios.get('/management/star/getStarServiceItemList', {
        params: { star_service_id: item.star_service_id }
      })))
      this.executionServiceList = res.map((item, index) => {
        item.children = serviceItemList[index]
        return item
      })
      this.loading = false
    },

    delRow (key, scope) {
      if (scope.$index === 0) {
        // 清空执行价目表第一栏
        this.data[key].price.splice(scope.$index, 1)
        this.data[key].price.push(
          {
            'star_service_id': null,
            'total_price': null,
            'star_service_item_id': null,
            'unit_price': null,
            'star_service_item_name': ''
          }
        )
      } else {
        this.data[key].price.splice(scope.$index, 1)
      }
    },
    getTotalPrice (row) {
      row.total_price = row.unit_price * row.number
      return row.total_price
    },
    addRow (key) {
      this.data[key].price.push(
        {
          'star_service_id': null,
          'total_price': null,
          'star_service_item_id': null,
          'unit_price': null,
          'star_service_item_name': ''
        }
      )
    },
    addRightRow (key) {
      this.data[key].price.push(
        {
          'right_service_name': '',
          'right_service_id': null,
          'workday': null,
          'right_service_item_id': null,
          'right_service_item_name': '',
          'number': null,
          'flexibility': 1
        }
      )
    },
    handleServiceItemSelect (list, row) {
      row.star_service_item_id = list.find(o => o.star_service_item_name === row.star_service_item_name).star_service_item_name === '3rd party cost' ? '' : list.find(o => o.star_service_item_name === row.star_service_item_name).star_service_item_id
    },
    handleRightServiceItemSelect (list, row) {
      row.right_service_item_id = this.isZh ? list.find(o => o.right_service_item_name_ch === row.right_service_item_name).right_service_item_id : list.find(o => o.right_service_item_name === row.right_service_item_name).right_service_item_id
    },
    handleServiceItemInput (servive, row) {
      row.star_service_item_id = ''
      row.unitPrice = 0
    },
    async validator () {
      const res = []
      if (!this.data.star_offer_date.start_date || !this.data.star_offer_date.end_date) {
        res.push(this.$t('请填写合作期限'))
      }

      if (this.data.star_offer_price.tax_total_price > 1000000000 || this.data.star_execution_price.tax_total_price > 1000000000) {
        res.push(this.$t('预算超出上限'))
      }

      this.data.star_offer_price.price.forEach(item => {
        if (!item.star_service_item_name || !item.star_service_name) {
          res.push(this.$t('请填写必填项'))
        }

        if (!Number.isInteger(item.number) || item.number < 0) {
          res.push(this.$t('数量格式不正确'))
        }
      })

      this.data.star_right_price.price.forEach(item => {
        if (!item.right_service_name || !item.right_service_item_name) {
          res.push(this.$t('请填写必填项'))
        }

        if (item.flexibility) {
          if (item.is_confirmed == null) {
            res.push(this.$t('请填写必填项'))
          }
          if (!Number.isInteger(item.number) || item.number < 0) {
            res.push(this.$t('数量格式不正确'))
          }
          if (!Number.isInteger(item.workday)) {
            res.push(this.$t('工作日个数不正确'))
          }
        } else {
          if (!Number.isInteger(item.number) || item.number < 0) {
            res.push(this.$t('数量格式不正确'))
          }
          if (!Number.isInteger(item.workday)) {
            res.push(this.$t('工作日个数不正确'))
          }
        }
      })
      if (this.executionPriceRequired) {
        this.data.star_execution_price.price.forEach(item => {
          if (!item.star_service_id || !item.star_service_item_name) {
            res.push(this.$t('请填写必填项'))
          }

          if (!Number.isInteger(item.number) || item.number < 0) {
            res.push(this.$t('数量格式不正确'))
          }
        })
      } else {
        this.data.star_execution_price.price.some(item => {
          if (item.star_service_id || item.star_service_item_name || item.unit_price || item.number) {
            if (!item.star_service_id || !item.star_service_item_name || !item.unit_price || !item.number) {
              res.push(this.$t('执行价目表信息不完整'))
            }
          }
        })
      }

      if (res.length > 0) {
        this.$message.error(res[0])
        return false
      }

      return true
    },
    async handleConfirm () {
      if (this.viewMode) {
        this.$emit('close')
        return
      }

      if (!await this.validator()) return
      console.log('this.data', this.data)

      this.$emit('confirm', this.data, this.index)
    },
    closeDialog () {
      this.$emit('close')
    },
    onBeforeUpload (file) {
      // const result = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel.sheet.macroenabled.12' || file.type === 'application/vnd.ms-excel.sheet.macroEnabled.12'
      const filePattern = /\.xls(x|m)$/
      const result = filePattern.test(file.name)
      if (!result) {
        this.$message.error('文件格式错误，请重新上传')
      }
      // 请上传不大于500K的图片
      return result
    },
    checkShouldDisabledRightItem (id) {
      return this.data.star_right_price.price.map(i => i.right_service_item_id).includes(id)
    }
  },
  components: {
    UploadMultipleFile,
    NewUploadFile,
    UploadedFileDisplay,
    InputWithCommas,
    VueNumeric
  }
}
</script>

<style lang='stylus'>
$border = solid 1px #979797

.unistar-quotation-dialog
  .icon-shanchu1
    color: #3370d2;
    line-height: 29px;
    font-size:10px;
    cursor:pointer;
    margin-right: 8px
  .export-kol-report__btn
    display block
    margin-left auto
    margin-right 55px
  .el-table
    // padding 10px
    // box-shadow 0 1px 10.5px 0 rgba(72, 150, 230, 0.12)
    &:before
      content none
    tr
      th
        &:nth-child(1)
          padding-left 14px
      td
        &:nth-child(1)
          .cell
            padding-left 0
  .el-dialog__body
    padding 0px 25px 0px
    height 560px
    overflow auto
    .tab
      margin-bottom 10px
  .el-dialog__header
    text-align left
  .el-dialog__footer
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 32px;
    border-top: 1px solid #f0f0f0;
  .el-range-editor--mini.el-input__inner
    width 210px
  .table-footer
    display flex
    margin-top 10px
    justify-content space-between
    .el-button
      margin-left 24px
    .total_price
      span
        margin-left 50px
  .title
    font-size 16px
    color #2c3031
    font-weight 500
  .el-button--text
    font-weight normal
.quotation-detail__summary
  padding 10px 55px
  font-size $font-small
  > div
    display flex
    justify-content flex-end
    line-height 28px
    > span:first-child
      margin-right 10px
  .el-input
    width 100px
</style>
